import React from 'react'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { Route, Switch } from 'react-router-dom'
import {
	ProductsRoutes,
	MerchantBranchesRoutes,
	BlocksRoutes,
	BlockingRuleRoutes,
	UnBlockRequestsRoutes,
	RecommendationRoutes,
	BlockProductGroupRoutes,
	MassAssignRoutes,
} from 'Pages/orders'

export const OrdersRoutes = () => {
	return (
		<Switch>
			<Route
				path={FrontUrls.orders.block_product_groups}
				key={FrontUrls.orders.block_product_groups}
				component={BlockProductGroupRoutes}
			/>
			<Route
				path={FrontUrls.orders.products}
				key={FrontUrls.orders.products}
				component={ProductsRoutes}
			/>
			<Route
				path={FrontUrls.orders.merchant_branches}
				key={FrontUrls.orders.merchant_branches}
				component={MerchantBranchesRoutes}
			/>
			<Route path={FrontUrls.orders.block} key={FrontUrls.orders.block} component={BlocksRoutes} />
			<Route
				path={FrontUrls.orders.blocking_rule}
				key={FrontUrls.orders.blocking_rule}
				component={BlockingRuleRoutes}
			/>
			<Route
				path={FrontUrls.orders.unblock_requests}
				key={FrontUrls.orders.unblock_requests}
				component={UnBlockRequestsRoutes}
			/>
			<Route
				path={FrontUrls.orders.recommendations}
				key={FrontUrls.orders.recommendations}
				component={RecommendationRoutes}
			/>
			<Route
				path={FrontUrls.orders.mass_assign_products}
				key={FrontUrls.orders.mass_assign_products}
				component={MassAssignRoutes}
			/>
		</Switch>
	)
}
